<div class="bg-white p-4">
  <div style="width: fit-content">
    <div class="alert alert-success" style="flex-direction: column; width: fit-content">
      <div class="alert-text">
        <h4 class="alert-heading">Ready to migrate your Pay Me Store products?</h4>
        <p> 1. Copy your migration code.</p>
        <p> 2. Go to <a href="https://www.paymestore.co/" class="text-dark fw-bold">https://www.paymestore.co/</a> and log in.</p>
        <p> 3. Go to the migration page and enter your migration code. </p>
        <p> 4. You will receive an email once the migration is complete </p>
        <hr>
        <div class="mb-0">
          Note: Your migration code can be used only once and it migrates your events, invoices and
          physical products only. Don't share this code.
        </div>
      </div>
    </div>

    <div class="row mb-2" style="font-size: 16px">
      <div class="col-12">
        <div class="url-field m-auto">
          <div class="d-flex justify-content-center cursor-pointer" (click)=copyInputMessage(code)>
            Your migration code is
            <mat-icon style="margin-left: .75rem" class="text-dark">content_copy</mat-icon> &nbsp; <span class="text-dark">{{code}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
